// In-app navigation guard. BrowserRouter has no useBlocker, so the admin sidebar asks here before navigating.
// shortcut: covers sidebar navigation and tab close/reload only (not the browser Back button or header links); move to a data router to cover all.
let leaveMessage: string | null = null;

export const setLeaveGuard = (message: string | null) => {
  leaveMessage = message;
};

export const confirmLeave = () => !leaveMessage || window.confirm(leaveMessage);
